import React from 'react';
import { CreatePasswordModal } from '~/legacy/components/modals';
import SetPassword from './SetPassword';

const CreatePassword = () => {
  return <SetPassword SetPasswordModalClass={CreatePasswordModal} />;
};

export default CreatePassword;
